import React from 'react'
import ContainerComponent from '../../components/ContainerComponent';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BigNumComponent from '../../components/BigNumComponent';

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: 40,
        fontWeight: 550,
        [theme.breakpoints.down('sm')]: {
            fontSize: 25,
        },

    },
    numb: {
        fontSize: '300px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '150px !important',
        },
    }
}))

const EmptyPage = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <ContainerComponent >
            <Container maxWidth='md'>
                <Box display='flex' justifyContent='center' mt='80px' mb='40px'>
                    <BigNumComponent speed={50} number={localStorage.getItem('lastError') || 404} defaultNumb={500} disableZero className={classes.numb} />
                </Box>
                <Typography variant='h1' align='center' className={classes.title} dangerouslySetInnerHTML={{ __html: t('empty_page.title') }} />
            </Container>
        </ContainerComponent>
    )
}


export default React.memo(EmptyPage);